import axios from 'axios';

const BASE = '/produccion/maquinas';

export default {
  index() {
    return axios.get(BASE);
  },
  create(data) {
    return axios.post(BASE, data);
  },
  update(id, data) {
    return axios.put(`${BASE}/${id}`, data);
  },
  destroy(id) {
    return axios.delete(`${BASE}/${id}`);
  },
};
